const state = () => ({
    loading: false,
    ringLoading: false,
    heightHeader: null,
    heightFooter: null
});

const getters = {
    getHeigthHeader: (state, getters) => {
        return state.heightHeader;
    },
    getHeigthFooter: (state, getters) => {
        return state.heightFooter;
    }
};

const mutations = {
    setLoading(state, loading) {
        state.loading = loading;
    },
    setRingLoading(state, ringLoading) {
        state.ringLoading = ringLoading;
    },
    setHeightHeader(state, heightHeader) {
        state.heightHeader = heightHeader;
    },
    setHeightFooter(state, heightFooter) {
        state.heightFooter = heightFooter;
    }
};

const actions = {};

export default {
    state,
    getters,
    actions,
    mutations
};
